export default __webpack_public_path__ + "static/media/free.3d0ed2dd.png";